import { Toast } from 'bootstrap'
import escapeHtml from 'src/escapeHtml'
import closeButton from 'src/modalShell'

// Bootstrap autohides a toast after 5s and the handler below then removes the element, so nothing
// records what the user was told. A failing feature spec reported `the toasts rendered were: []`
// because the error toast explaining the failure had already been deleted (TODO.md T-72). Every
// toast passes through showToasts -- both addToast's and the ones a .js.erb renders server-side --
// so one line here covers all of them. Bounded, because a Turbolinks session never reloads the page.
const TOAST_LOG_LIMIT = 20

function logToast(toastTarget) {
  const text = (toastTarget.textContent || '').trim()
  if (!text) return

  window.__toastLog = (window.__toastLog || []).concat(text).slice(-TOAST_LOG_LIMIT)
}

export function showToasts() {
  document.querySelectorAll('.toast.new').forEach((toastTarget) => {
    logToast(toastTarget)
    toastTarget.addEventListener('shown.bs.toast', function () {
      $(this).removeClass('new')
    })
    toastTarget.addEventListener('hidden.bs.toast', function () {
      this.remove()
    })
    return new Toast(toastTarget).show()
  })
}

export function addToast(text, type, sign_in = 'normal') {
  if (text == null) {
    toastText(I18n.t("errors.unexpected_error"), 'error', sign_in)
  } else if (Array.isArray(text)) {
    text.forEach(function myFunction(item, index, arr) {
      toastText(item, type, sign_in)
    })
  } else if (typeof text == 'object') {
    Object.keys(text).forEach(function(key) {
      if (typeof text[key] === 'string' || text[key] instanceof String) {
        toastText(text[key], type, sign_in)
      } else {
        addToast(text[key], type, sign_in)
      }
    })
  } else {
    toastText(text, type, sign_in)
  }
}

// 🚨 **The escape is HERE, at the output boundary — `TODO.md` U-97.** Both branches below `prepend`
// a markup string, which jQuery PARSES as HTML, so every value reaching them was markup. The import's
// error message interpolates spreadsheet cells, and `F-124`'s `error_label` put a raw `product_code` in
// front of every invalid inventory row — the common path, not the rare one.
//
// 🔑 **Text in, line breaks out — and that is why there is no `html: true` opt-in.** U-97 proposed an
// explicit markup opt-in, but all four callers that need markup build
// `I18n.t('…error') + '<br/>' + error_message`, so an opt-in would hand exactly those four an unescaped
// path again: the hole would move, not close. Escaping and then converting `\n` means the boundary owns the
// only markup that exists, and no caller needs an escape hatch.
//
// ⚠️ **The server emits `\n` now, not `<br/>`** — `import_customers_job` and
// `import_service_description_job` were changed with this. A `<br/>` arriving from anywhere is escaped and
// shows as literal text, which is the correct and visible failure.
// 📌 `escapeHtml` escapes quotes too, which matters because `type` and the icon are interpolated into
// attributes in the same string.
function toastBody(text) {
  return escapeHtml(text).replace(/\n/g, '<br/>')
}

function toastText(text, type, sign_in) {
  let textType = 'bg-success text-white'
  let iconType = 'check'
  let btnType = 'btn-close-white'
  if (type == 'error') {
    textType = 'bg-danger text-white'
    iconType = 'x'
    btnType = 'btn-close-white'
  } else if (type == 'alert') {
    textType = 'bg-warning text-white'
    iconType = 'exclamation'
    btnType = 'btn-close-white'
  }

  if (sign_in == 'normal') {
    $('.toast-container').prepend("<div class='toast fade " + textType + " new border-0 h4 w-100' role='alert' aria-live='assertive' aria-atomic='true'><div class='d-flex'><div class='toast-body'><table><tbody><tr><td class='p-0 pe-2'><i class='bi bi-" + iconType + "-circle'></i></td><td class='p-0'>" + toastBody(text) + "</td><td class='p-0 ps-2'>" + closeButton({ dismiss: 'toast', className: btnType }) + "</td></tr></tbody></table></div></div></div>")
  } else {
    $('.toast-container').prepend("<div class='toast fade new border-0 w-100' role='alert' aria-live='assertive' aria-atomic='true'> <div class='toast-header " + textType + "'><i class='bi bi-" + iconType + "-circle me-2'></i> <strong class='me-auto'>" + toastBody(text) + "</strong></div></div>")
  }
}
